import { Box, Typography } from "@mui/material";
import { ButtonIconType, ButtonVariant, StandardButton } from "../button/primary.button";
import { ITableHeaderButton } from "../../_common/interface/buttons/iTableHeaderButton.interface";


export function PaperTableHeader(params: {
    buttons?: Array<ITableHeaderButton>,
    title: string,
}) {

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2,
            }}>

            <Typography variant="h4">{params.title}</Typography>

            <Box sx={{ display: 'flex', gap: 1 }}>

                {(params.buttons && params.buttons.length > 0) && params.buttons.map((m: ITableHeaderButton, i: number) =>
                    <StandardButton
                        key={`${i}_header_button_${params.title}`}
                        icon={m.icon}
                        variant={m.variant}
                        onClick={m.onClick}>
                        {m.label}
                    </StandardButton>
                )}

            </Box>

        </Box >
    );

}
